






















import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import { dataService } from "../../services/data/data-service";
import { ProjectEvent } from "../../model/project";
import "./vote.less";
import {getVotingEnabledData} from "@/services/getProjectData/getProjectData";

@Component({})
export default class Vote extends Vue {
  @Prop() year!: Number;
  @Prop() id!: Number;
  @Prop() isCompact!: Boolean;
  private maxHovered = -1;
  private ranking: string | null = null;
  private subscription;
  public currentPosition = -1;
  private voting_enabled = 0;
  private animateIndex = -1;

  async mounted() {
    this.voting_enabled = getVotingEnabledData();
    this.subscription = dataService.categoryData.data.subscribe(
      (ev: ProjectEvent) => {
        if (ev.event == "voteSuccess" && ev.data.id == this.id) {
          this.ranking = ev.data.vote;
          this.currentPosition = ev.data.currentPosition;
        }
        if (ev.event == "fetch") {
          this.ranking = dataService.getVote(this.id);
        }
      }
    );
    await this.$nextTick();
    this.ranking = dataService.getVote(this.id);
  }

  beforeDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  get currentRanking() {
    return this.maxHovered > -1
      ? this.maxHovered + 1
      : this.ranking == undefined || this.ranking == null
      ? 0
      : this.ranking;
  }

  get isJury() {
    return dataService.isJuryUser();
  }

  get isVoted() {
    return this.ranking != null;
  }


  vote(points) {
    this.animate(points);
    dataService.vote(this.year, this.id, points);
    this.voted(points)
  }

  animate(points){
    let index = points-1;
    this.animateIndex = index;
    let self = this;
    setTimeout(function () {
      self.animateIndex = -1;
    },1000);

  }

  trans(key) {
    return translate(key);
  }

  @Emit("voted")
  voted(points) {
  }
}
